import { render, staticRenderFns } from "./index_rendimiento.vue?vue&type=template&id=c936fd6a"
import script from "./index_rendimiento.vue?vue&type=script&lang=js"
export * from "./index_rendimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports